"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../theme");
exports.useStyles = (0, react_jss_1.createUseStyles)({
    root: {},
    row: {
        marginBottom: "0px",
    },
    inputsWrapper: {
        display: "flex",
        width: "100%",
    },
    inputLabel: {
        width: "100%",
        flexGrow: 1,
    },
    delete: {
        color: theme_1.colors.delete,
        cursor: "pointer",
        marginBottom: "10px"
    },
    add: {
        color: "#0073aa",
        cursor: "pointer",
        marginTop: "15px",
        marginBottom: "15px",
    }
});
